// http://vuex.vuejs.org/en/mutations.html#using-constants-for-mutation-types
export const SET_TOKEN = 'Auth//SET_TOKEN'
export const SET_USER = 'Auth//SET_USER'
